import React from "react";
import { graphql } from "gatsby";
import { MDXProvider } from "@mdx-js/react";
import config from '../../data/SiteConfig';


import Layout from "../components/layout";
import SEO from "../components/seo";
import './article.scss';
import { MDXRenderer } from "gatsby-plugin-mdx";

interface IQueryProps {
  data: {
    mdx: any
  }
}


export default class Article extends React.Component<IQueryProps, {}> {
  render() {
    const postNode = this.props.data.mdx;
    const post = postNode.frontmatter;
    return (
      <Layout>
        <div className="post template">
          <SEO title={`${post.title} | ${config.siteTitle}`}/>
          <div className="post page">
            <div className="article figure">
              <div className="HeaderContainer">
                <small className="sub">
                    {post.date}
                </small>
                <h1 className="title">
                  {post.title}
                </h1>
              </div>
              <MDXRenderer>{postNode.body}</MDXRenderer>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export const pageQuery = graphql`
query($slug: String) {
  mdx(fields: { slug: { eq: $slug } }) {
    id
    excerpt
    body
    frontmatter {
      title
      date
    }
  }
}
`;